import {documentDetailState} from "./state";
import {loadDocumentDetailAction, downloadComponentsAction} from './effects';
import {loadDocumentDetailSuccessAction, loadDocumentDetailFailureAction} from './reducer';

export const models = {
  state: documentDetailState,
  reducers: {
    loadDocumentDetailSuccessAction,
    loadDocumentDetailFailureAction,
  },
  effects: dispatch => ({
    loadDocumentDetailAction: function (id) {
      return loadDocumentDetailAction.call(this, id, dispatch);
    },
    downloadComponentsAction: function (_, rootState) {
      return downloadComponentsAction.call(this, rootState);
    },
  }),
  selectors: (slice) => ({
    documents() {
      return slice((myDocs) => myDocs.documents);
    },
    detailInfo() {
      return slice((myDocs) => myDocs.detailInfo);
    },
    isLoading() {
      return slice((myDocs) => myDocs.isLoading);
    },
    isError() {
      return slice((myDocs) => myDocs.isError);
    },
    errorMessage() {
      return slice((myDocs) => myDocs.errorMessage);
    },
  }),
};
